import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import { getSidebar, getTabIndex, setTabIndex } from '../reducers/sidebar';
import TabPanel from './TabPanel';
import LayerList from './LayerList';
import Plan from './Plan';
import Sponsors from './Sponsors';

// const important = (s) => `${s} !important`;

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    top: 0,
    [theme.breakpoints.down('xs')]: {
      top: 0,
    },
    position: 'relative',
    whiteSpace: 'nowrap',
    width: 310,
    height: 'calc(100vh - 64px)',
    // transition: important(theme.transitions.create('width', {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.standard,
    // })),
    background: '#fafafa',
    borderRadius: '0 !important',
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    // transition: important(theme.transitions.create('width', {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.standard,
    // })),
    width: 0,
  },
}));

const Sidebar = () => {
  const sidebar = useSelector(getSidebar);
  const tabIndex = useSelector(getTabIndex);
  const dispatch = useDispatch();

  const classes = useStyles({ sidebar });

  const tabChange = (event, index) => {
    dispatch(setTabIndex(index));
  };

  return (
    <Paper
      className={clsx(classes.drawerPaper, !sidebar && classes.drawerPaperClose)}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabIndex} onChange={tabChange} sx={{ marginLeft: '12px' }}>
          <Tab label="Layers" />
          <Tab label="Plan" />
          <Tab label="Sponsors" />
        </Tabs>
      </Box>
      <TabPanel index={0} value={tabIndex}>
        <LayerList />
      </TabPanel>
      <TabPanel index={1} value={tabIndex}>
        <Plan />
      </TabPanel>
      <TabPanel index={2} value={tabIndex}>
        <Sponsors />
      </TabPanel>
    </Paper>
  );
};

export default Sidebar;
